export default {
  bind(el, binding) {
    const { enabled = true, onEnter, onLeave } = binding.value || {};

    el.intersectionEnabled = enabled;
    el.intersectionOnEnter = onEnter;
    el.intersectionOnLeave = onLeave;

    // Создаём наблюдатель за пересечениями
    el.intersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        // Проверяем, виден ли элемент полностью
        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          if (
            el.intersectionEnabled &&
            typeof el.intersectionOnEnter === "function"
          ) {
            el.intersectionOnEnter(entry);
          }
        } else if (entry.intersectionRatio < 1) {
          if (
            el.intersectionEnabled &&
            entry.isIntersecting == false &&
            typeof el.intersectionOnLeave === "function"
          ) {
            el.intersectionOnLeave(entry);
          }
        }
      },
      {
        threshold: [0, 1], // Проверяем начальное и полное пересечение
      }
    );

    if (enabled) {
      el.intersectionObserver.observe(el);
    }
  },
  update(el, binding) {
    const { enabled = true, onEnter, onLeave } = binding.value || {};

    el.intersectionEnabled = enabled;
    el.intersectionOnEnter = onEnter;
    el.intersectionOnLeave = onLeave;

    // Останавливаем или запускаем наблюдение
    if (enabled) {
      el.intersectionObserver.observe(el);
    } else {
      el.intersectionObserver.unobserve(el);
    }
  },
  unbind(el) {
    // Очищаем наблюдателя
    if (el.intersectionObserver) {
      el.intersectionObserver.disconnect();
    }
    el.intersectionObserver = null;
  },
};
